import { Button, Drawer, Flex, Row, Typography } from "antd";
import styled, { css } from "styled-components";

import { ResponsiveSelect } from "~/Atom/ResponsiveSelect";
import { TRADE_GOTHIC_NEXT_FONT_FAMILY } from "~/Constant/Theme/constants";
import { TokenProps } from "~/types";

export const MobileDrawer = styled(Drawer)<TokenProps>`
  width: 100vw;
  .ant-drawer-body {
    padding: 0.5rem !important;
  }
  zindex: 10 !important;
`;

export const MapContainer = styled.div`
  height: 100%;
  max-height: 100%;
  max-width: 100%;
  width: 100%;
`;

export const MapRoot = styled.div`
  height: 100%;
  max-height: 100%;
  max-width: 100%;
  width: 100%;

  .marker {
    transition: transform 0.3s ease-in-out;
  }
  .marker:hover {
    transform: translate(0, -25%) scale(1.5);
  }
  .gm-style .gm-style-iw-c {
    margin-bottom: 1rem;
  }
  .gm-style [role="dialog"].gm-style-iw-c {
    padding: 1rem !important;
  }
  .gm-style .gm-style-iw-d {
    overflow: hidden !important;
  }
  z-index: 1;
`;

export const LocationListingsContainer = styled(Flex)<TokenProps>`
  background: ${(props) => props.$token.colorWhite};
  max-height: 100%;
  ${(props) =>
    props.$breakpoints?.md
      ? css`
          min-width: 25rem;
          padding: 0.5rem 1rem;
        `
      : css`
          max-width: 100%;
          min-width: inherit;
          padding: 0.25rem;
        `};
`;

export const LocationFlexContainer = styled(Flex).attrs({
  gap: "small",
  vertical: true,
})`
  width: 100%;
  max-height: 100%;
  max-width: 100%;
`;

export const LocationListingsOverlayChild = styled.div<TokenProps>`
  width: 100%;
`;

export const LocationCardListContainer = styled(LocationListingsOverlayChild)`
  border: 0;
  font-family: ${TRADE_GOTHIC_NEXT_FONT_FAMILY} !important;
  margin: 1rem 0 0 0;
  overflow-y: auto;
  scrollbar-width: none;
  width: 100%;
`;

export const HeaderSuperText = styled(Typography.Text)<TokenProps>`
  color: ${(props) => props.$token.colorPrimary};
  font-size: 0.875rem;
  font-weight: 700;
  letter-spacing: 0.1875rem !important;
  text-transform: uppercase !important;
`;

export const HeaderText = styled(Typography.Title).attrs({
  level: 1,
})`
  margin: 0 0 0.25rem 0 !important;
  padding: 0;
  font-size: 1.875rem !important;
  font-weight: 800 !important;
`;

export const HeaderBodyText = styled(Typography.Link)<TokenProps>`
  color: ${(props) => props.$token.colorText} !important;
  display: block;
  font-weight: 400 !important;
`;
export const HeaderSubText = styled(Typography.Link)<TokenProps>`
  color: ${(props) => props.$token.colorText} !important;
  font-weight: 700 !important;
  &:hover {
    text-decoration: underline;
  }
`;

export const FilterOption = styled(Button).attrs({
  ghost: true,
  type: "primary",
})<TokenProps & { $active?: boolean }>`
  line-height: 1rem;
  display: inline-block;
  border-radius: 1rem;
  text-transform: uppercase !important;
  color: ${(props) =>
    props.$active
      ? props.$token.colorWhite
      : props.$token.colorText} !important;
  background: ${(props) =>
    props.$active ? props.$token.colorPrimary : "transparent"} !important;
  font-weight: 700;
  font-size: 0.75rem;
  padding: 0.25rem 1.375rem !important;
  border: 1px solid ${(props) => props.$token.colorPrimary};
  height: inherit;
`;

export const LocationFinderFilterSelect = styled(ResponsiveSelect)`
  display: block;
  & .ant-select-selection-item {
    margin-left: -0.375rem !important;
  }
  & .ant-select-selection-placeholder {
    margin-left: -0.875rem;
  }
`;

export const FilterRow = styled(Row)<TokenProps>`
  #locationFinderGeosuggest .ant-select-selector .ant-select-selection-wrap {
    padding-left: 1.75rem !important;
    input {
      padding-left: 2.25rem !important;
    }
  }

  #locationFinderGeosuggest .ant-select-selector,
  #locationFinderGeosuggest:hover .ant-select-selector,
  #locationFinderFilter .ant-select-selector,
  #locationFinderFilter:hover .ant-select-selector {
    border: 1px solid ${(props) => props.$token.colorPrimary};
    border-radius: 0.5rem;

    & + .ant-select-arrow,
    .ant-select-arrow + .ant-select-clear {
      top: 26px;
    }
  }
`;
